/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col } from "antd";
import Menus from "./Menus";
import SettingsImg from "../../../assets/images/icon_menus/SettingsIcon.json";
import { useDispatch, useSelector } from "react-redux";
import { ClientProfiling, Clients, ClientList, ClientType } from "../../Shared/components/Dashboard";
import action from "./redux/actions";
import { checkModuleViewPermission } from '../../../helpers/utilities';
import { Swiper, SwiperSlide } from "swiper/react";
import crudActions from "../../CRUD/redux/actions";
import usePrevious from "../../Shared/components/Previous";

const YounoteAdmin = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { younoteAdminDashboardDetails } = useSelector(state => state.younoteAdminDashboardReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const { history } = props;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [search, setSearch] = useState('');
    const [skip, setSkip] = useState(0);

    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);

    const leftRef = useRef('');
    const dispatch = useDispatch();


    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            //var height = document.getElementById('mainHeader').offsetHeight;
            setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Younote Admin', history)) {
                loadTasks();
                setTimeout(() => {
                    calculateHeight();
                }, 100);
            }
        }
    }, [roleManagement]);


    const loadTasks = useCallback(() => {
        dispatch({ type: action.YOUNOTE_ADMIN_DASHBOARD_START, url: 'younoteAdminDashboard' });
        dispatchFilter(sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };

        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ businessType: { like: '%' + search.trim() + '%' } });
            or['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }   
        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'business',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const classes = customStyles();

    return (
        <React.Fragment>
            <MainHeader  {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Younote Admin', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={20} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            younoteAdminDashboardDetails?.paying_count && Object.keys(younoteAdminDashboardDetails?.paying_count).length > 0 ?
                                                <ClientProfiling details={younoteAdminDashboardDetails?.paying_count} title="Younote Client Profiling" />
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            younoteAdminDashboardDetails?.group_by_customerTypes && Object.keys(younoteAdminDashboardDetails?.group_by_customerTypes).length > 0 ?
                                                <Clients details={younoteAdminDashboardDetails?.group_by_customerTypes} title="Younote Client" />
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={clsx(classes.thirdBox, classes.paddingBottom10)}>
                        <div className={clsx(classes.boxBorderH)} style={{ height: (height) + 'px' }}>
                            <Swiper
                                id="swiper"
                                virtual
                                autoplay={{
                                    delay: 5000,
                                    pauseOnMouseEnter: true
                                }}
                                allowTouchMove={false}
                                loop
                                pagination={{ clickable: true }}>
                                <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                    <ClientList
                                        handleSearch={(v) => setSearch(v)}
                                        details={getList}
                                        loadMore={loadMore}
                                        loadMoreTask={() => loadMoreTask()}
                                        loadMoreContent={loadMoreContent}
                                        dispatchFilter={(sortBy, sortOrder) => dispatchFilter(sortBy, sortOrder)}
                                        sortOrder={sortOrder} sortBy={sortBy}
                                        onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                                        title="List of Younote Clients" />
                                </SwiperSlide>
                                <SwiperSlide key={`slide-2`} style={{ listStyle: "none" }}>
                                    <ClientType details={younoteAdminDashboardDetails} title="Younote Clients List By Type & Location" />
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default YounoteAdmin